$ = require('jquery')

require('fancybox/source/jquery.fancybox')
require('fancybox/source/helpers/jquery.fancybox-thumbs')
require('jquery-touchswipe')


module.exports =
	init: (payload) ->
		{$target} = payload

		margin = if $(window).width() >= 700 then [70, 70, 0, 70] else [50, 0, 0, 0]

		$target.find('.js-lightbox').fancybox(
			padding: 0
			margin: margin
			nextEffect: 'none'
			prevEffect: 'none'
			scrolling: 'no'
			helpers:
				thumbs:
					width: 130
					height: 73
				overlay:
					locked: true
			tpl:
				closeBtn : '<a href="javascript:;" class="fancybox-close fancybox-margin" ><span class="vhide">Zavřít</span><span class="icon icon-close"></span></a>'
				next: '<a href="javascript:;" class="fancybox-nav fancybox-next"><span class="vhide">Další</span><span class="icon icon-angle-right"></span></a>'
				prev: '<a href="javascript:;" class="fancybox-nav fancybox-prev"><span class="vhide">Předchozí</span><span class="icon icon-angle-left"></span></a>'
			afterLoad: ->
				hasGallery = $(this.element).data('gallery')
				isFullscreen = $(this.element).data('fullscreen')

				if hasGallery is false
					delete this.helpers.thumbs
				else
					$('html').addClass('fancybox-gallery')

					thumbs =
						width: this.helpers.thumbs.width
						height: this.helpers.thumbs.height

					if !isFullscreen? or isFullscreen is true
						this.helpers.thumbs =
							width: 160
							height: 90
					else
						this.helpers.thumbs = thumbs
			beforeShow: ->
				title = $(this.element).data('title')
				caption = $(this.element).data('caption')
				isFullscreen = $(this.element).data('fullscreen')

				if title?
					this.title = "<p class='h5'>#{title}</p>"

				if caption?
					this.title += "<p>#{caption}</p>"

				if !isFullscreen? or isFullscreen is true
					$('html').addClass('fancybox-fullscreen')
			afterShow: ->
				$(document).swipe(
					swipe: (event, direction, distance, duration, fingerCount) ->
						switch direction
							when 'right' then $.fancybox.prev()
							when 'left' then $.fancybox.next()

				)
			afterClose: ->
				$(document).swipe('destroy')
				$('.fancybox-fullscreen').removeClass('fancybox-fullscreen')
				$('.fancybox-gallery').removeClass('fancybox-gallery')
		)



// WEBPACK FOOTER //
// ./src/js/components/lightbox.coffee